module.exports = __webpack_public_path__ + "img/38-min.ea27340b.jpg";